/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import { progressBarCss, filledBarCss } from './index.styles';

class ProgressBar extends SafePureComponent {
  safeRender() {
    const { className, percentage } = this.props;
    const filledBarWidthCss = {
      '.is-not-IE &': {
        width: `${(percentage * 100).toFixed(2)}%`,
      },
    };

    return (
      <div css={progressBarCss} className={className}>
        <div css={[progressBarCss, filledBarCss, filledBarWidthCss]} />
      </div>
    );
  }
}

ProgressBar.displayName = 'ProgressBar';

ProgressBar.propTypes = {
  className: PropTypes.string,
  percentage: PropTypes.number,
};

export default ProgressBar;
